import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const exportExerciseResults = async (exportRequest) => {
  var timeZoneName = new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'long' }).substring(4);
  const result = await tryPost(`/reports/exportResults?timeZoneName=${timeZoneName}`, exportRequest);
  return result.data;
}